/**
 * 历史记录组件
 */

import { useState, useEffect } from 'react';
import { Button, Input, Row, Col, Tooltip, message } from 'antd';
import { MenuUnfoldOutlined, StarOutlined, BlockOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { AddRequestHeaders, UjoinParams } from '../../incs/FunHelper';
import CNF from '../../incs/Config';
// import 
import HistoryEntry from './HistoryEntry';

const History = (props) => {
    const [title, setTitle] = useState('');
    const [isCollect, setIsCollect] = useState('');
    const [isStar, setIsStar] = useState('');
    const [pageSize, setPageSize] = useState(CNF.pageSize * 2);
    const [dialogues, setDialogues] = useState([]);
    const [scrollHeight, setScrollHeight] = useState(0);
    const [dialogueUlid, setDialogueUlid] = useState(props.dialogueUlid);

    /***
     * 获取历史会话
     */
    const getDialogues = () => {
        var params = {
            project_code: props.service ? props.service : CNF.projectCode.toLowerCase(),
            model: props.model.value,
            version: props.versionInfo.value,
            title: title,
            is_collect: isCollect,
            is_star: isStar,
            page_size: pageSize,
        }
        $.ajax({
            url: `${CNF.api}dialogues${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        setDialogues(data.dat);
                    } else {
                        setDialogues([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    useEffect(() => {
        //  当点击“新建对话”时，清除选择的历史记录
        setDialogueUlid(props.dialogueUlid)
    }, [props.dialogueUlid]);

    useEffect(() => {
        if (props.isOpenHistory) {
            //  请求接口获取历史会话
            getDialogues();
        }
    }, [props.service, props.model, props.versionInfo, props.isOpenHistory, title, isCollect, isStar, pageSize]);
    return <>
        <div style={{ padding: 10, height: '100%' }}>
            <div style={{ height: 44, lineHeight: '44px' }}>
                <div style={{
                    display: 'inline-block',
                    width: 'calc(100% - 30px)',
                    background: '#F8F8FA',
                    borderRadius: 5,
                    padding: '0 5px',
                }}>
                    <div style={{
                        display: 'inline-block',
                        width: 'calc(100% - 55px)',
                    }}>
                        <Input
                            style={{ borderColor: '#F8F8FA', boxShadow: 'none' }}
                            value={title}
                            placeholder='历史会话'
                            onChange={(e) => { setTitle(e.target.value) }}
                            onPressEnter={() => { getDialogues() }}
                        />
                    </div>
                    <div style={{
                        display: 'inline-block',
                        width: 50,
                        marginLeft: 5,
                    }}>
                        <Row>
                            <Col span={12}>
                                <Tooltip placement='bottom' color='#fff' title={<span style={{ color: '#939394', fontSize: 12 }}>收藏</span>}>
                                    <Button type='link' style={{
                                        color: isCollect ? '#FF904D' : '#939394',
                                        width: '100%',
                                    }}
                                        onClick={(e) => {
                                            setIsCollect(isCollect ? '' : '是');
                                            e.preventDefault();
                                        }} icon={<BlockOutlined />} />
                                </Tooltip>
                            </Col>
                            <Col span={12}>
                                <Tooltip placement='bottom' color='#fff' title={<span style={{ color: '#939394', fontSize: 12 }}>标星</span>}>
                                    <Button type='link' style={{
                                        color: isStar ? '#FF904D' : '#939394',
                                        width: '100%',
                                    }}
                                        onClick={(e) => {
                                            setIsStar(isStar ? '' : '是')
                                            e.preventDefault();
                                        }} icon={<StarOutlined />} />
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div style={{ display: 'inline-block', width: '30px' }}>
                    <Button type='link' style={{
                        color: '#939394',
                        height: 30,
                        width: 30,
                    }}
                        onClick={(e) => {
                            props.changeIsOpenHistory(false);
                            e.preventDefault();
                        }} icon={<MenuUnfoldOutlined />}
                    />
                </div>
            </div>
            <div style={{
                height: 'calc(100% - 64px)',
                scrollbarColor: '#d9d9d9 transparent',
                scrollbarWidth: 'thin',
                overflowY: 'auto',
                marginTop: 5,
            }}
                onScroll={(e) => {
                    let d = e.target;
                    let clientHeight = d.clientHeight;   //  div高度
                    let _scrollHeight = d.scrollHeight;  //  滚动条高度
                    let scrollTop = d.scrollTop;         //  滚动条离顶部的高度
                    if (scrollTop + clientHeight === _scrollHeight && _scrollHeight > scrollHeight) {
                        //  设置滚动条高度
                        setScrollHeight(_scrollHeight);
                        // //  调用接口拉数据
                        setPageSize(pageSize + CNF.pageSize);
                    }
                }}
            >
                {
                    dialogues && dialogues.map((item) => {
                        return <HistoryEntry
                            key={item.key}
                            data={item}
                            getDialogues={getDialogues}
                            getDialogueContents={props.getDialogueContents}
                            dialogueUlid={dialogueUlid}
                        />
                    })
                }
            </div>
        </div>
    </>
}

export default History;